export type WorkflowStatus = 'in_progress' | 'completed';

export const WORKFLOW_STATUS_LABELS: Record<WorkflowStatus, string> = {
  in_progress: 'In Progress',
  completed: 'Completed',
};

export function normalizeWorkflowStatus(value?: string | null): WorkflowStatus {
  return value === 'completed' ? 'completed' : 'in_progress';
}

export function isWorkflowCompleted(value?: string | null): boolean {
  return normalizeWorkflowStatus(value) === 'completed';
}

export function workflowStatusBadgeClass(status: WorkflowStatus): string {
  if (status === 'completed') {
    return 'bg-emerald-50 text-emerald-700 ring-emerald-600/15';
  }
  return 'bg-amber-50 text-amber-800 ring-amber-600/15';
}

export function workflowStatusTextClass(status: WorkflowStatus): string {
  if (status === 'completed') {
    return 'text-emerald-700';
  }
  return 'text-amber-800';
}
